/**
 * Normalizes a docs URL by ensuring it follows the proper format
 * @param href The URL to normalize
 * @returns Normalized docs URL
 */
export function normalizeDocsHref(href: string): string {
  // If it's already a full URL, return as is
  if (href.startsWith('http://') || href.startsWith('https://')) {
    return href;
  }

  // If it starts with /docs/, return as is (relative URL)
  if (href.startsWith('/docs/')) {
    return href;
  }

  // If it starts with /, but not /docs/, prepend /docs
  if (href.startsWith('/')) {
    return `/docs${href}`;
  }

  // Otherwise, prepend /docs/ 
  return `/docs/${href}`;
}